<template>
  <div class="flex items-center min-w-0 text-2sm text-text-secondary mr-4">
    <MKIcons v-if="showIcon"
             :icon="category.icon || ''"
             class="mr-3-5 text-xs flex-none"
             :style="markStyle"/>
    <span class="truncate min-w-0">{{ category.title }}</span>
  </div>
</template>

<script>
import MKIcons from "@/components/icons/MKIcons/MKIcons";
import {isBankIcon} from "@/components/icons/MKIcons/icons";
import {EXPENSE_ICON_BG, ICON_GLYPH, INCOME_ICON_BG, categoryIconStyle} from "@/components/icons/MKIcons/iconPalette";

export default {
  name: "Category",
  components: {MKIcons},
  props: {
    category: {
      type: Object,
      required: true
    },
    withIcon: {
      type: Boolean,
      default: false
    },
    iconKind: {
      type: String,
      default: 'expense'
    }
  },
  computed: {
    showIcon() {
      return this.withIcon && !!(this.category && this.category.icon);
    },
    markStyle() {
      if (!this.showIcon) return '';
      const fallback = this.iconKind === 'income'
        ? {bg: INCOME_ICON_BG, color: ICON_GLYPH}
        : {bg: EXPENSE_ICON_BG, color: ICON_GLYPH};
      return categoryIconStyle(
        this.category.icon_bg,
        fallback,
        isBankIcon(this.category.icon)
      ) + 'width:22px;height:22px;';
    }
  }
}
</script>

<style scoped>

</style>